import * as api from "../constants/api";
import * as axiosUtils from "../utils/axiosUtils";

export function getBrevstatistikkHistorikk(svarUtReferanseId) {
  return axiosUtils.GetAll(api.GET_BREVSTATISTIKK_HISTORIKK(svarUtReferanseId));
}
